import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

const UpgradeCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1a0527] via-[#2D063E] to-[#1a0527] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-[#2D063E]/50 border border-gray-700 rounded-2xl p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-gray-700/50 flex items-center justify-center">
            <XCircle className="w-8 h-8 text-gray-400" />
          </div>
          
          <h1 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h1>
          <p className="text-gray-400 mb-6">
            No worries! Your payment was cancelled and you haven't been charged. 
            You can upgrade anytime when you're ready.
          </p>
          
          <div className="space-y-3">
            <Button 
              onClick={() => navigate('/dashboard')}
              variant="outline"
              className="w-full border-gray-600 text-gray-300 hover:bg-gray-800"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Return to Dashboard
            </Button>
            <Button 
              onClick={() => navigate('/upgrade')}
              className="w-full bg-gradient-to-r from-[#df1283] to-[#FF7901]"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Try Again
            </Button>
          </div>
          
          <p className="text-xs text-gray-500 mt-6">
            Questions? Contact support at info@unclonedmarketing.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default UpgradeCancel;
